import { createSlice } from '@reduxjs/toolkit'
import { ResourceState, ViewResource } from '../type'

const trainingState: ResourceState = {
    resourceList: [],
}

const resourcesSlice = createSlice({
    name: 'adminresources',
    initialState: trainingState,
    reducers: {
        resoucelist: (state, action) => {
            state.resourceList = action.payload.data
            // state.totalCount = action.payload.totalCount
            // state.pageSize = action.payload.pageSize
        },
        deleteresource: (state, action) => {
            state.resourceList = state.resourceList.filter(
                (brand: ViewResource) => brand.resourceId !== action.payload
            )
        },
    },
})

export default resourcesSlice.reducer

export const { deleteresource, resoucelist } = resourcesSlice.actions
